export const REDUCER_NAME = "metaDataSlice";

// DTO for sending data (request payload)
export interface iMetaDataDTO {
    meta_name: string;
    meta_content: string;
}

// Response structure for single meta tag
export interface iMetaTag {
    id: string;
    meta_name: string;
    meta_content: string;
}

// Response structure from API
export interface iMetaDataResponse {
    metaTags: iMetaTag[];
}
export interface iDomainBuyPayload {
  domain: string;
  years: number;
  currency: string;
  price: number | null;
  registrant: {
    firstName?: string;
    lastName?: string;
    email?: string;
    phone?: string;
    address1?: string;
    city?: string;
    state?: string;
    zip?: string;
    country?: string;
  };
}


export interface iMetaDataState {
    getDomainList: iMetaTag[];
    isLoading: boolean;
    errorMessage: string | null;
}